import { render } from "./ReplaceRecipeDialog.vue?vue&type=template&id=90b7c390"
import script from "./ReplaceRecipeDialog.vue?vue&type=script&lang=js"
export * from "./ReplaceRecipeDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__